import resetSchedulesViewStateStore from "../actions/resetSchedulesViewStateStore";
import clearScheduleDataInView from "../actions/clearScheduleDataInView";
import { orchestrator } from "satcheljs";
import { IPreviewSchedulePageStore } from "../../../previewSchedulePage";
import { SchedulesViewStateStore } from "../store/schema/SchedulesViewStateStore";
import schedulesViewStateStore from "../store/store";
/**
 * Reset SchedulesViewStateStore when resetSchedulesViewStateStore action is called
 */
export default orchestrator(resetSchedulesViewStateStore, (actionMessage: {
    viewState?: IPreviewSchedulePageStore | SchedulesViewStateStore
}) => {
    clearScheduleDataInView(actionMessage.viewState ? actionMessage.viewState : schedulesViewStateStore());
});
